<template>
    <div>
        <div class="header">
            <div class="header_t">
                <span class="header_ttw">行业专业解决方案</span>
                <p class="header_tf">智能管理系统 + 系统集成 + 智能调度</p>
            </div>
            <img src="../assets/imgs/solutionOne.png" class="fruit_img">
        </div>
        <!-- 智能管理系统 -->
        <div class="bottom_b">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">智能管理系统</div>
                        <div class="product_pc">
                            <div class="product_pc_left">
                                <span>域名创建</span>
                            </div>
                            <div class="product_pc_right">
                                <span>代理伙伴，若您有代理我们产品的意向欢迎您和我们取得联系，获取产品相关培训及代理方案。</span>
                            </div>
                        </div>
                        <div class="product_pcTwo">
                            <div class="product_pc_left">
                                <span>配置修改</span>
                            </div>
                            <div class="product_pc_right">
                                <span>通过易凡云控制台、API进行任何配置修改后，均可自动联动所属厂商进行全自动配置更新，支持单厂商节点、多厂商节点。</span>
                            </div>
                        </div>
                        <div class="product_pc">
                            <div class="product_pc_left">
                                <span>账单计费</span>
                            </div>
                            <div class="product_pc_right">
                                <span>为用户提供不同规格流量包，进行消耗抵扣1TB=1024GB。实现跨多厂商节点计费抵扣，当天账单以次日17：00为准。</span>
                            </div>
                        </div>
                        <div class="product_pcTwo">
                            <div class="product_pc_left">
                                <span>智能调度</span>
                            </div>
                            <div class="product_pc_right">
                                <span>根据厂商闲忙时价格、节点质量、节点峰值等综合情况，为客户提供详细的厂商线路的融合，接入易凡云CNAME后系统自动调度厂商节点。</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 系统集成 -->
        <div class="center_c">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">系统集成</div>
                        <div class="product_pct_t">
                            <div class="product_pc">
                                <img src="../assets/imgs/solutionTwo.png" alt="">
                                <p>调度系统</p>
                                <span>易凡云集成DNS系统在全国地区实现TL秒级生效，切拥有DNS集群防御实现稳定调度服务。</span>
                            </div>
                            <div class="product_pc">
                                <img src="../assets/imgs/solutionThree.png" alt="">
                                <p>巡检系统</p>
                                <span>域名配置状态为异常后系统第一时间联系管理人员，并自动开始巡查异常状态。保障业务加速稳定状态。</span>
                            </div>
                            <div class="product_pc">
                                <img src="../assets/imgs/solutionFour.png" alt="">
                                <p>节点系统</p>
                                <span>集成多家厂商接口统一能力，持AB厂商到AC/BC等多种一间切换能力，自动完成配置同步。</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 调度讲解 -->
        <div class="zzBo_b">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">调度讲解</div>
                        <div class="product_pc_top">
                            <div class="product_pc">
                                <p>厂商单线</p>
                                <span>通过客户指定厂商节点线路，实行全天固定厂商节点分发进行加速。</span>
                            </div>
                            <div class="product_list_one">
                                <p>自动切换</p>
                                <span>易凡云默认分配华为云火山云进行节点调优，单价得到高额的优惠。</span>
                            </div>
                            <div class="product_list_two">
                                <p>人工切换</p>
                                <span>特定环境、指定厂商等特殊需求。根据诉求进行具体厂商的配置</span>
                            </div>
                            <div class="product_list_three">
                                <p>厂商切换</p>
                                <span>支持单厂商到多厂商的切换（N+1,N+N）， 支持多厂商更换（AB/AC）</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
  name: "Fruit",
  data() {
    return {};
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.header {
  position: relative;
}
.header .header_t {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 150px;
  left: 348px;
animation: header_t 2s;
}

@keyframes header_t {
  0% {
    opacity: 0;
    transform: translate3d( -200%, 0, 0);
  }
}
.header .header_t .header_tf {
  font-size: 20px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
}
.header .header_t .header_ttw {
  letter-spacing: 5px;
  font-size: 40px;
  font-family: MF LiHei (Noncommercial)-Regular, MF LiHei (Noncommercial);
  font-weight: 600;
  color: #0066ff;
  line-height: 40px;
  margin-bottom: 46px;
}
.header .fruit_img {
  height: 492px;
  width: 100%;
}
.bottom_b {
  height: 837px;
  background: #f5f7fd;
  margin-top: -5px;
}
.bottom_b .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: product_pc_one 2s;
}
@keyframes product_pc_one {
  0% {
    opacity: 0;
    transform: translate3d( 0,-100%, 0);
  }
}
.bottom_b .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 55px 0;
}
.bottom_b .product_pc_one .product_pc {
  width: 1256px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom_b .product_pc_one .product_pc .product_pc_left {
  width: 286px;
  height: 138px;
  background: linear-gradient(315deg, #0066ff 0%, #e1edff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
}
.bottom_b .product_pc_one .product_pc .product_pc_right {
  display: flex;
  align-items: center;
  padding-left: 69px;
  background: rgb(209, 227, 255);
  width: 882px;
  height: 138px;
}
.bottom_b .product_pc_one .product_pc .product_pc_right span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  width: 721px;
  color: #282c33;
  line-height: 40px;
}
.bottom_b .product_pc_one .product_pcTwo {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 1256px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_left {
  width: 286px;
  height: 138px;
  background: rgb(209, 227, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #282c33;
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_right {
  display: flex;
  align-items: center;
  padding-left: 69px;
  background: #fff;
  width: 882px;
  height: 138px;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_right span {
  font-size: 16px;
  width: 721px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
}
.center_c {
  height: 511px;
}
.center_c .product_pct {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.center_c .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 55px 0;
}
.center_c .product_pc_one .product_pct_t {
  display: flex;
  justify-content: space-evenly;
}
.center_c .product_pc_one .product_pct_t .product_pc {
  width: 320px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.center_c .product_pc_one .product_pct_t .product_pc p {
  margin: 34px 0 16px 0;
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 18px;
}
.center_c .product_pc_one .product_pct_t .product_pc span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 28px;
}
.zzBo_b {
  height: 749px;
  background: #f5f7fd;
}
.zzBo_b .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.zzBo_b .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 58px 0 68px 0;
}
.zzBo_b .product_pc_one .product_pc_top {
  width: 1140px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: space-between;
  height: 476px;
}
.zzBo_b .product_pc_one .product_pc_top .product_pc {
  background-image: url("../assets/imgs/solutionFive.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 544px;
  height: 213px;
  position: relative;
  animation: product_pc 1s;
}

@keyframes product_pc {
  0% {
    opacity: 0;
    transform: translate3d( -200%, 0, 0);
  }
}
.zzBo_b .product_pc_one .product_pc_top .product_pc p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  top: 42%;
  left: 8%;
  line-height: 18px;
}
.zzBo_b .product_pc_one .product_pc_top .product_pc span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  width: 320px;
  position: absolute;
  bottom: 15%;
  left: 8%;
}
.zzBo_b .product_pc_one .product_pc_top .product_list_one {
  background-image: url("../assets/imgs/solutionSix.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 544px;
  height: 213px;
  position: relative;
animation: product_list_one 1s;
}

@keyframes product_list_one {
  0% {
    opacity: 0;
    transform: translate3d( 0,-200%, 0);
  }
}
.zzBo_b .product_pc_one .product_pc_top .product_list_one p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  top: 42%;
  left: 8%;
  line-height: 18px;
}
.zzBo_b .product_pc_one .product_pc_top .product_list_one span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  width: 320px;
  position: absolute;
  bottom: 15%;
  left: 8%;
}
.zzBo_b .product_pc_one .product_pc_top .product_list_two {
  background-image: url("../assets/imgs/solutionSeive.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 544px;
  height: 213px;
  position: relative;
animation: product_list_two 1s;
}

@keyframes product_list_two {
  0% {
    opacity: 0;
    transform: translate3d( -200%,0, 0);
  }
}
.zzBo_b .product_pc_one .product_pc_top .product_list_two p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  top: 42%;
  left: 8%;
  line-height: 18px;
}
.zzBo_b .product_pc_one .product_pc_top .product_list_two span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  width: 320px;
  position: absolute;
  bottom: 15%;
  left: 8%;
}
.zzBo_b .product_pc_one .product_pc_top .product_list_three {
  background-image: url("../assets/imgs/solutionEight.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 544px;
  height: 213px;
  position: relative;
  animation: product_list_three 1s;
}

@keyframes product_list_three {
  0% {
    opacity: 0;
    transform: translate3d( 0, -200%, 0);
  }
}
.zzBo_b .product_pc_one .product_pc_top .product_list_three p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  top: 42%;
  left: 8%;
  line-height: 18px;
}
.zzBo_b .product_pc_one .product_pc_top .product_list_three span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  width: 320px;
  position: absolute;
  bottom: 15%;
  left: 8%;
}
</style>